import React, { useState } from 'react';
import PropTypes from 'prop-types';
import _noop from 'lodash-es/noop';

import {
  DropDownContainer,
  DropDownHeader,
  DropDownList,
  DropDownListContainer,
  DropDownListHeader,
  DropDownListOption,
  ListItem,
} from './style';
import useComponentVisible from './useComponentVisible';
import { ThreeDotIcon } from '../SVGs/commonSVGs';

const DottedDropDown = ({ options, setSelectedOption }) => {
  const {
    ref,
    isComponentVisible,
    setIsComponentVisible,
  } = useComponentVisible();
  const [isOpen, setIsOpen] = useState(false);
  let componentMarginTop = '0px';

  switch (options.length) {
    case 1:
      componentMarginTop = '27px';
      break;
    case 2:
      componentMarginTop = '45px';
      break;
    default:
      componentMarginTop = '0px';
  }

  const toggling = () => {
    setIsOpen(!isOpen);
    setIsComponentVisible(!isOpen);
  };

  const onOptionClicked = value => () => {
    setSelectedOption(value);
    setIsOpen(false);
  };

  return (
    <div ref={ref}>
      {!(isOpen && isComponentVisible) && (
        <DropDownHeader onClick={toggling}>
          {' '}
          <ThreeDotIcon />
          {' '}
        </DropDownHeader>
      )}
      <DropDownContainer>
        {isOpen && isComponentVisible && (
          <DropDownListContainer>
            <DropDownList componentMarginTop={componentMarginTop}>
              {options.map((option, index) => (
                <ListItem>
                  <DropDownListOption
                    isActive={option.isActive}
                    onClick={onOptionClicked(option)}
                  >
                    {' '}
                    {option.label}
                    {' '}
                  </DropDownListOption>
                  {index === 0 && (
                    <DropDownListHeader onClick={toggling}>
                      {' '}
                      <ThreeDotIcon />
                      {' '}
                    </DropDownListHeader>
                  )}
                </ListItem>
              ))}
            </DropDownList>
          </DropDownListContainer>
        )}
      </DropDownContainer>
    </div>
  );
};

DottedDropDown.propTypes = {
  options: PropTypes.array,
  setSelectedOption: PropTypes.func,
};

DottedDropDown.defaultProps = {
  options: [],
  setSelectedOption: _noop,
};

export default DottedDropDown;
